module.exports = __webpack_public_path__ + "img/checked-star.c8b7183b.svg";